/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import Sidebar from './Sidebar';

/**
 * Sidebar module exports
 */
export { Sidebar as default };



// WEBPACK FOOTER //
// ./src/js/Sidebar/index.js